// GtPager — compact Mercor-style pager. Prev/next arrows, an X–Y of Z range,
// and a small segmented page-size toggle (no native <select> anywhere).
// Shared across Candidates / Roles / Clients tables.
export default function GtPager({ page, pageSize, total, onPage, onPageSize, sizes = [25, 50, 100] }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, page * pageSize + pageSize);
  return (
    <div className="gtpg">
      <div className="gtpg-range">{from}–{to} of {total}</div>
      <div className="gtpg-nav">
        <button type="button" className="gtpg-arrow" disabled={page === 0} onClick={() => onPage(Math.max(0, page - 1))} aria-label="Previous page">‹</button>
        <span className="gtpg-page">Page {page + 1} of {totalPages}</span>
        <button type="button" className="gtpg-arrow" disabled={page + 1 >= totalPages} onClick={() => onPage(page + 1)} aria-label="Next page">›</button>
      </div>
      <div className="gtpg-sizes">
        {sizes.map(n => (
          <button key={n} type="button" className={'gtpg-size' + (n === pageSize ? ' gtpg-size--on' : '')} onClick={() => onPageSize(n)}>{n}</button>
        ))}
      </div>
    </div>
  );
}
